// Alle Orte im 20km Radius um Itzehoe mit spezifischen Daten
export const cities = [
  {
    name: 'Itzehoe',
    slug: 'itzehoe',
    population: 32725,
    distance: 0,
    keywords: ['Kreisstadt', 'Zentrum', 'Klinikum'],
    landmarks: ['Stadtpark', 'Marktplatz', 'Klinikum Itzehoe', 'Fußgängerzone'],
    postal: '25524, 25525, 25524',
    specific: 'Als Kreisstadt ist Itzehoe das Zentrum unserer Region. Viele unserer Patienten wohnen in zentraler Lage oder in den ruhigen Wohngebieten wie Edendorf und Wellenkamp.',
    demographics: 'Mit über 32.000 Einwohnern und einer alternden Bevölkerung ist der Bedarf an häuslicher Pflege stetig wachsend.'
  },
  {
    name: 'Glückstadt',
    slug: 'glueckstadt',
    population: 11410,
    distance: 12,
    keywords: ['Hafenstadt', 'Elbe', 'historisch'],
    landmarks: ['Hafen', 'Marktplatz', 'Elbdeich'],
    postal: '25348',
    specific: 'Glückstadt mit seinem historischen Stadtkern und der Lage an der Elbe erfordert besondere Aufmerksamkeit bei der Anfahrt. Wir kennen alle Wege und sind in unter 20 Minuten bei Ihnen.',
    demographics: 'Die Hafenstadt mit 11.400 Einwohnern hat einen hohen Anteil älterer Menschen, die in ihren vertrauten vier Wänden bleiben möchten.'
  },
  {
    name: 'Wilster',
    slug: 'wilster',
    population: 4302,
    distance: 18,
    keywords: ['Stadt an der Wilsterau', 'ländlich'],
    landmarks: ['Colosseum', 'Stadtkirche', 'Marktplatz'],
    postal: '25554',
    specific: 'Wilster ist eine überschaubare Stadt mit familiärem Charakter. Die kurzen Wege ermöglichen uns flexible Pflegezeiten und spontane Besuche.',
    demographics: 'In der kleineren Stadt mit 4.300 Einwohnern kennt man sich. Vertrauen und persönliche Empfehlungen sind hier besonders wichtig.'
  },
  {
    name: 'Kellinghusen',
    slug: 'kellinghusen',
    population: 8000,
    distance: 15,
    keywords: ['Stör', 'Kleinstadt'],
    landmarks: ['Störbrücke', 'Rathaus', 'Marktplatz'],
    postal: '25548',
    specific: 'Kellinghusen liegt idyllisch an der Stör. Wir betreuen hier sowohl in der Innenstadt als auch in den umliegenden ländlichen Bereichen.',
    demographics: 'Die Stadt mit etwa 8.000 Einwohnern hat eine wachsende Zahl pflegebedürftiger Senioren, die professionelle Unterstützung zuhause benötigen.'
  },
  {
    name: 'Krempe',
    slug: 'krempe',
    population: 2450,
    distance: 14,
    keywords: ['historisch', 'Marschland'],
    landmarks: ['Marktplatz', 'Kirche St. Nikolai'],
    postal: '25361',
    specific: 'Die historische Stadt Krempe mit ihrem denkmalgeschützten Ortskern liegt uns am Herzen. Wir respektieren die besonderen Anforderungen der alten Gebäude.',
    demographics: 'Krempe hat etwa 2.450 Einwohner. Viele Senioren leben seit Jahrzehnten in der Stadt und wünschen sich Pflege in gewohnter Umgebung.'
  },
  {
    name: 'Hohenlockstedt',
    slug: 'hohenlockstedt',
    population: 6100,
    distance: 16,
    keywords: ['Geest', 'Gemeinde'],
    landmarks: ['Rathaus', 'Sportpark'],
    postal: '25551',
    specific: 'Hohenlockstedt in der Geest erreichen wir von Dägeling aus in unter 25 Minuten. Die gute Verkehrsanbindung ermöglicht uns zuverlässige Pflegezeiten.',
    demographics: 'Mit 6.100 Einwohnern ist Hohenlockstedt eine lebendige Gemeinde mit wachsendem Bedarf an häuslicher Seniorenpflege.'
  },
  {
    name: 'Heiligenstedten',
    slug: 'heiligenstedten',
    population: 3200,
    distance: 8,
    keywords: ['direkt bei Itzehoe', 'Nachbargemeinde'],
    landmarks: ['Dorfzentrum'],
    postal: '25524',
    specific: 'Heiligenstedten grenzt direkt an Itzehoe und ist von unserem Standort in unter 15 Minuten erreichbar. Hier sind wir besonders schnell vor Ort.',
    demographics: 'Die ländliche Gemeinde mit etwa 3.200 Einwohnern schätzt persönliche Betreuung und kurze Reaktionszeiten.'
  },
  {
    name: 'Lägerdorf',
    slug: 'laegerdorf',
    population: 3800,
    distance: 10,
    keywords: ['Zementwerk', 'Industriegemeinde'],
    landmarks: ['Zementwerk', 'Ortszentrum'],
    postal: '25566',
    specific: 'Lägerdorf ist als Industriestandort bekannt. Wir betreuen hier besonders viele ehemalige Werksangehörige und ihre Familien.',
    demographics: 'Etwa 3.800 Einwohner, viele davon im Ruhestand nach langer Berufstätigkeit im örtlichen Werk.'
  },
  {
    name: 'Breitenburg',
    slug: 'breitenburg',
    population: 1600,
    distance: 7,
    keywords: ['Schloss', 'ländlich'],
    landmarks: ['Schloss Breitenburg', 'Dorfkirche'],
    postal: '25524',
    specific: 'Die kleine Gemeinde Breitenburg mit dem bekannten Schloss liegt uns sehr nahe. Hier kennen wir viele Familien persönlich.',
    demographics: 'Circa 1.600 Einwohner in ruhiger, ländlicher Umgebung. Hoher Anteil an Eigenheimbesitzern im Seniorenalter.'
  },
  {
    name: 'Wewelsfleth',
    slug: 'wewelsfleth',
    population: 1800,
    distance: 16,
    keywords: ['Stör', 'Schifffahrt'],
    landmarks: ['Hafen', 'Störbrücke'],
    postal: '25599',
    specific: 'Wewelsfleth an der Stör ist ein idyllisches Örtchen. Die Anfahrt über die Landstraße dauert etwa 25 Minuten.',
    demographics: 'Rund 1.800 Einwohner, viele mit maritimem Hintergrund. Traditionsbewusste Gemeinde mit Bedarf an vertrauensvoller Pflege.'
  },
  {
    name: 'Brokdorf',
    slug: 'brokdorf',
    population: 900,
    distance: 19,
    keywords: ['Elbe', 'Kernkraftwerk'],
    landmarks: ['Elbdeich', 'Dorfzentrum'],
    postal: '25576',
    specific: 'Brokdorf liegt direkt an der Elbe. Trotz der etwas weiteren Anfahrt betreuen wir hier zuverlässig mehrere Familien.',
    demographics: 'Kleine Gemeinde mit etwa 900 Einwohnern. Enge Dorfgemeinschaft, wo persönliche Empfehlungen viel wert sind.'
  },
  {
    name: 'Kollmar',
    slug: 'kollmar',
    population: 850,
    distance: 20,
    keywords: ['Elbe', 'Deich'],
    landmarks: ['Elbdeich', 'Hafen'],
    postal: '25377',
    specific: 'Kollmar an der Elbmündung ist der westlichste Punkt unseres Servicebereichs. Die malerische Lage am Deich schätzen wir sehr.',
    demographics: 'Ca. 850 Einwohner in ruhiger Deichlage. Viele Senioren genießen hier ihren Ruhestand mit Elbblick.'
  },
  {
    name: 'Horst',
    slug: 'horst-holstein',
    population: 6500,
    distance: 11,
    keywords: ['Gemeinde', 'zentral'],
    landmarks: ['Marktplatz', 'Rathaus'],
    postal: '25358',
    specific: 'Horst (Holstein) ist eine zentrale Gemeinde mit guter Infrastruktur. Von hier aus betreuen wir auch die umliegenden Dörfer.',
    demographics: 'Etwa 6.500 Einwohner mit steigendem Pflegebedarf durch demografischen Wandel.'
  },
  {
    name: 'Schenefeld',
    slug: 'schenefeld-steinburg',
    population: 2300,
    distance: 9,
    keywords: ['Steinburg', 'bei Itzehoe'],
    landmarks: ['Ortszentrum'],
    postal: '25560',
    specific: 'Schenefeld liegt sehr nah an Itzehoe und ist in 15 Minuten erreichbar. Viele unserer Pflegekräfte wohnen in der Umgebung.',
    demographics: 'Rund 2.300 Einwohner in überschaubarer Gemeinde mit persönlichem Charakter.'
  },
  {
    name: 'Münsterdorf',
    slug: 'muensterdorf',
    population: 1200,
    distance: 13,
    keywords: ['ländlich', 'Geest'],
    landmarks: ['Dorfkirche'],
    postal: '25587',
    specific: 'Münsterdorf ist eine ruhige Gemeinde auf der Geest. Hier betreuen wir vorwiegend Senioren in Eigenheimen mit Gärten.',
    demographics: 'Etwa 1.200 Einwohner, ländlich geprägt mit Fokus auf häuslicher Pflege statt Heimen.'
  },
  {
    name: 'Dägeling',
    slug: 'daegeling',
    population: 350,
    distance: 0,
    keywords: ['unser Sitz', 'Heimatgemeinde'],
    landmarks: ['Lindenbusch'],
    postal: '25578',
    specific: 'Dägeling ist unser Firmensitz am Lindenbusch 13a. Von hier aus starten alle unsere Pflegeeinsätze. Wir sind tief in der Gemeinde verwurzelt.',
    demographics: 'Kleine Gemeinde mit 350 Einwohnern. Als lokaler Arbeitgeber kennen uns hier alle persönlich.'
  },
  {
    name: 'Ecklak',
    slug: 'ecklak',
    population: 600,
    distance: 12,
    keywords: ['kleine Gemeinde'],
    landmarks: ['Dorfzentrum'],
    postal: '25560',
    specific: 'Ecklak ist eine sehr überschaubare Gemeinde, wo jeder jeden kennt. Persönliche Empfehlungen sind hier Gold wert.',
    demographics: 'Etwa 600 Einwohner, enge Dorfgemeinschaft.'
  },
  {
    name: 'Kaisborstel',
    slug: 'kaisborstel',
    population: 550,
    distance: 14,
    keywords: ['ländlich'],
    landmarks: ['Dorfkirche'],
    postal: '25572',
    specific: 'Kaisborstel erreichen wir über die Landstraße. Die ländliche Lage schätzen viele unserer Patienten.',
    demographics: 'Ca. 550 Einwohner in ländlicher Idylle.'
  }
];

// Service-spezifische Daten
export const services = [
  {
    id: 'grundpflege',
    name: 'Grundpflege',
    slug: 'grundpflege',
    price: 45,
    description: 'Körperpflege, An- und Auskleiden, Ernährung, Mobilität',
    icon: 'HeartHandshake',
    pflegekasse: 'Wird von Pflegekasse ab Pflegegrad 2 übernommen'
  },
  {
    id: 'behandlungspflege',
    name: 'Behandlungspflege',
    slug: 'behandlungspflege',
    price: 55,
    description: 'Medikamentengabe, Wundversorgung, Injektionen, Blutdruckmessung',
    icon: 'Stethoscope',
    pflegekasse: '100% Übernahme auf ärztliche Verordnung'
  },
  {
    id: 'hauswirtschaft',
    name: 'Hauswirtschaft',
    slug: 'hauswirtschaft',
    price: 35,
    description: 'Einkaufen, Kochen, Reinigung, Wäschepflege',
    icon: 'Home',
    pflegekasse: 'Entlastungsbetrag 125€/Monat nutzbar'
  },
  {
    id: 'demenzbetreuung',
    name: 'Demenzbetreuung',
    slug: 'demenzbetreuung',
    price: 50,
    description: 'Spezialisierte Betreuung bei Demenz und Alzheimer',
    icon: 'Users',
    pflegekasse: 'Je nach Pflegegrad 761€ bis 2.200€ monatlich'
  },
  {
    id: 'palliativpflege',
    name: 'Palliativpflege',
    slug: 'palliativpflege',
    price: 60,
    description: 'Würdevolle Pflege in der letzten Lebensphase',
    icon: 'Heart',
    pflegekasse: 'Spezielle Palliativversorgung wird übernommen'
  },
  {
    id: 'verhinderungspflege',
    name: 'Verhinderungspflege',
    slug: 'verhinderungspflege',
    price: 45,
    description: 'Urlaubsvertretung für pflegende Angehörige',
    icon: 'Calendar',
    pflegekasse: 'Bis 1.612€ pro Jahr verfügbar'
  }
];

// FAQ-Templates pro Stadt
export const cityFaqTemplates = (city) => [
  {
    question: `Was kostet ambulante Pflege in ${city.name}?`,
    answer: `Die Kosten für ambulante Pflege in ${city.name} liegen 2026 bei durchschnittlich 45€ pro Stunde für Grundpflege und 55€ für Behandlungspflege. Die Pflegekasse übernimmt je nach Pflegegrad zwischen 761€ und 2.200€ monatlich. Für viele unserer Patienten in ${city.name} bedeutet das: Die Pflege ist vollständig durch die Kasse gedeckt. Wir beraten Sie kostenlos zu Ihren Ansprüchen.`
  },
  {
    question: `Wie schnell können Sie in ${city.name} mit der Pflege starten?`,
    answer: `In ${city.name} können wir in der Regel innerhalb von 24 Stunden mit der Pflege beginnen. Die Entfernung von unserem Standort in Dägeling beträgt nur ${city.distance} km, sodass wir Sie schnell erreichen. In Notfällen sind wir oft noch am selben Tag bei Ihnen. Rufen Sie uns einfach an: 0151 46173685.`
  },
  {
    question: `Sind Sie auch nachts und am Wochenende in ${city.name} erreichbar?`,
    answer: `Ja, wir sind rund um die Uhr erreichbar – auch nachts, am Wochenende und an Feiertagen. Unsere 24/7-Hotline erreichen Sie unter 0151 46173685. Für ${city.name} haben wir Bereitschaftsdienste, die binnen 4 Stunden vor Ort sein können.`
  },
  {
    question: `Welche Leistungen bieten Sie in ${city.name} an?`,
    answer: `In ${city.name} bieten wir das komplette Spektrum der ambulanten Pflege: Grundpflege (Körperpflege, Mobilität), Behandlungspflege (Medikamente, Wundversorgung), Hauswirtschaft (Einkauf, Kochen, Reinigung), Demenzbetreuung und Palliativpflege. Alle Leistungen werden von qualifizierten Pflegefachkräften erbracht.`
  },
  {
    question: `Haben Sie Erfahrung in ${city.name}?`,
    answer: `Ja, wir betreuen bereits mehrere Familien in ${city.name}. ${city.specific} Unsere Pflegekräfte kennen die örtlichen Gegebenheiten und arbeiten mit lokalen Ärzten und Apotheken zusammen.`
  }
];

// SEO-Keywords pro Stadt
export const getCityKeywords = (city) => [
  `ambulante pflege ${city.name.toLowerCase()}`,
  `pflegedienst ${city.name.toLowerCase()}`,
  `häusliche pflege ${city.name.toLowerCase()}`,
  `pflege zuhause ${city.name.toLowerCase()}`,
  `seniorenpflege ${city.name.toLowerCase()}`,
  `24 stunden pflege ${city.name.toLowerCase()}`,
  `grundpflege ${city.name.toLowerCase()}`,
  `behandlungspflege ${city.name.toLowerCase()}`,
  `pflegeservice ${city.name.toLowerCase()}`,
  `ambulanter pflegedienst ${city.name.toLowerCase()}`
];
